export default __webpack_public_path__ + "static/media/give-classes.c4f66599.svg";